import { useEffect, useState } from "react";
import { Plus, Pencil, Trash2, EyeOff, Star } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, imgSrc, money } from "../../lib/api";
import ProductForm from "./ProductForm";

export default function AdminProducts() {
  const [products, setProducts] = useState(null);
  const [editing, setEditing] = useState(undefined);
  const load = () => api.get("/admin/products").then((r) => setProducts(r.data));
  useEffect(() => { load(); }, []);

  const remove = async (p) => {
    if (!window.confirm(`Delete "${p.name}"? This can't be undone.`)) return;
    try {
      await api.delete(`/admin/products/${p.id}`);
      setProducts((ps) => ps.filter((x) => x.id !== p.id));
      toast.success("Product deleted");
    } catch (e) { toast.error(errMsg(e)); }
  };

  if (!products) return <p className="text-white/60">Loading products...</p>;
  return (
    <div data-testid="admin-products">
      <button className="btn-candy mb-5" onClick={() => setEditing(null)} data-testid="admin-add-product-button"><Plus className="h-5 w-5" /> Add product</button>
      <div className="space-y-3">
        {products.map((p) => (
          <div key={p.id} className="panel flex flex-wrap items-center gap-4 p-3" data-testid={`admin-product-row-${p.id}`}>
            <img src={imgSrc(p.image_url)} alt="" className="h-16 w-16 rounded-xl object-cover" />
            <div className="min-w-[160px] flex-1">
              <p className="font-bold">{p.name}</p>
              <p className="text-sm text-white/55">{p.category}</p>
            </div>
            <div className="flex gap-2">
              {p.featured && <Star className="h-4 w-4 fill-[var(--pink)] text-[var(--pink)]" />}
              {p.hidden && <span className="inline-flex items-center gap-1 rounded-full bg-white/10 px-2 py-0.5 text-xs font-bold"><EyeOff className="h-3 w-3" /> Hidden</span>}
            </div>
            <p className="w-28 font-display text-xl text-[var(--pink)]">{money(p.price)}{p.per_letter && <span className="font-sans text-xs text-white/60"> /letter</span>}{p.sizes?.length > 0 && <span className="block font-sans text-xs text-white/60">{p.sizes.map((s) => s.label).join(" / ")}</span>}</p>
            <button className="rounded-full p-2 hover:bg-white/10" onClick={() => setEditing(p)} data-testid={`admin-edit-product-${p.id}`} aria-label="Edit"><Pencil className="h-4 w-4" /></button>
            <button className="rounded-full p-2 hover:bg-white/10 hover:text-[var(--pink)]" onClick={() => remove(p)} data-testid={`admin-delete-product-${p.id}`} aria-label="Delete"><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
      {editing !== undefined && (
        <ProductForm key={editing?.id || "new"} product={editing} open onClose={() => setEditing(undefined)}
          onSaved={() => { setEditing(undefined); load(); }} />
      )}
    </div>
  );
}
